import serialize from 'serialize-javascript';
import jsStringEsc from 'js-string-escape';
export function getAdsSSRConfig(session) {
    var _session_features, _session, _session_features1, _session1, _session_adsTargeting;
    if (!session.adsEnabled) {
        return {
            shouldIncludeGak: false,
            shouldIncludeFreestar: false,
            shouldIncludeQuantcast: false,
            shouldIncludeHashtag: false,
            shouldIncludeTaboola: false,
            adsDebug: false
        };
    }
    // Logged in ads use GAK
    if (session.adProviders.includes('da')) {
        var _session_features2, _session2, _session_features3, _session3, _session_adsTargeting1;
        return {
            shouldIncludeFreestar: false,
            shouldIncludeHashtag: false,
            shouldIncludeGak: true,
            shouldIncludeQuantcast: true,
            shouldIncludeTaboola: false,
            adsDebug: ((_session2 = session) === null || _session2 === void 0 ? void 0 : (_session_features2 = _session2.features) === null || _session_features2 === void 0 ? void 0 : _session_features2.includes('ads_debug')) ? true : false,
            gakContext: toJsonString({
                features: (_session3 = session) === null || _session3 === void 0 ? void 0 : (_session_features3 = _session3.features) === null || _session_features3 === void 0 ? void 0 : _session_features3.reduce((p, c)=>{
                    p[c] = true;
                    return p;
                }, {}),
                targeting: (_session_adsTargeting1 = session.adsTargeting) === null || _session_adsTargeting1 === void 0 ? void 0 : _session_adsTargeting1.page,
                ppId: session.user.ppId
            })
        };
    }
    if (session.adProviders.includes('hashtag')) {
        var _session_features4, _session4, _session_features5, _session5, _session_adsTargeting2;
        return {
            shouldIncludeFreestar: false,
            shouldIncludeHashtag: true,
            shouldIncludeGak: false,
            shouldIncludeQuantcast: true,
            shouldIncludeTaboola: false,
            adsDebug: ((_session4 = session) === null || _session4 === void 0 ? void 0 : (_session_features4 = _session4.features) === null || _session_features4 === void 0 ? void 0 : _session_features4.includes('ads_debug')) ? true : false,
            gakContext: toJsonString({
                features: (_session5 = session) === null || _session5 === void 0 ? void 0 : (_session_features5 = _session5.features) === null || _session_features5 === void 0 ? void 0 : _session_features5.reduce((p, c)=>{
                    p[c] = true;
                    return p;
                }, {}),
                targeting: (_session_adsTargeting2 = session.adsTargeting) === null || _session_adsTargeting2 === void 0 ? void 0 : _session_adsTargeting2.page,
                ppId: session.user.ppId
            })
        };
    }
    // Taboola replaces Freestar
    if (session.adProviders.includes('taboola')) {
        var _session_features6, _session6, _session_features7, _session7, _session_adsTargeting3;
        return {
            shouldIncludeFreestar: false,
            shouldIncludeHashtag: false,
            shouldIncludeGak: false,
            shouldIncludeQuantcast: true,
            shouldIncludeTaboola: true,
            adsDebug: ((_session6 = session) === null || _session6 === void 0 ? void 0 : (_session_features6 = _session6.features) === null || _session_features6 === void 0 ? void 0 : _session_features6.includes('ads_debug')) ? true : false,
            gakContext: toJsonString({
                features: (_session7 = session) === null || _session7 === void 0 ? void 0 : (_session_features7 = _session7.features) === null || _session_features7 === void 0 ? void 0 : _session_features7.reduce((p, c)=>{
                    p[c] = true;
                    return p;
                }, {}),
                targeting: (_session_adsTargeting3 = session.adsTargeting) === null || _session_adsTargeting3 === void 0 ? void 0 : _session_adsTargeting3.page,
                ppId: session.user.ppId
            })
        };
    }
    // Anon uses freestar
    return {
        shouldIncludeFreestar: true,
        shouldIncludeGak: false,
        shouldIncludeQuantcast: true,
        shouldIncludeHashtag: false,
        shouldIncludeTaboola: false,
        adsDebug: ((_session = session) === null || _session === void 0 ? void 0 : (_session_features = _session.features) === null || _session_features === void 0 ? void 0 : _session_features.includes('ads_debug')) ? true : false,
        gakContext: toJsonString({
            features: (_session1 = session) === null || _session1 === void 0 ? void 0 : (_session_features1 = _session1.features) === null || _session_features1 === void 0 ? void 0 : _session_features1.reduce((p, c)=>{
                p[c] = true;
                return p;
            }, {}),
            targeting: (_session_adsTargeting = session.adsTargeting) === null || _session_adsTargeting === void 0 ? void 0 : _session_adsTargeting.page,
            ppId: session.user.ppId
        })
    };
}
export function isSSR() {
    return typeof window === 'undefined';
}
function jsStringEscape(json) {
    const result = jsStringEsc(json);
    return `"${result.replace(/<\/(script|style)/gi, '<\\/$1').replace(/<!--/g, '\\u003C!--')}"`;
}
export function toJsonString(jsObject, newrelic = null, newrelicSegmentName = '') {
    if (newrelic) {
        const segment = newrelicSegmentName || 'TO_JSON';
        return newrelic.startSegment(segment, true, ()=>jsStringEscape(serialize(jsObject, {
                isJSON: true
            })));
    }
    return jsStringEscape(serialize(jsObject, {
        isJSON: true
    }));
}
